/* CO2Art — the third layer's script (PLAN.md), loaded deferred from layout/theme.liquid after theme.js.
   Keep it small and dated; every block says why it exists. */

/* 2026-09-10 (S1) — in-page anchors land where they point. Concept renders every section from the
   third one on with `content-visibility: auto` (theme.css, [data-page-rendering] … .shopify-section),
   so a plain #hash jump is computed against placeholder heights: on the home the "Compare regulators"
   button landed ~2,400 px short (measured: the comparison section sat at 3,802 px before the jump and
   at 6,141 px after the sections above it rendered). Scrolling again across animation frames converges
   in two or three steps (measured 3706 → 6061 at 1440, 2805 → 5544 at 390). scroll-margin-top is honoured. */
(function () {
  function settle(el, done) {
    /* The shift arrives one or two frames AFTER the first scroll (measured: the anchor read 96 px right
       after scrollIntoView and 2,451 px two frames later), so stop only after two consecutive stable
       readings; re-scroll whenever it moved. Twelve frames at most. */
    var tries = 0, stable = 0;
    function check() {
      var top = el.getBoundingClientRect().top;
      var want = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
      if (Math.abs(top - want) <= 2) {
        if (++stable >= 2) { if (done) done(); return; }
      } else {
        stable = 0;
        el.scrollIntoView({ block: 'start' });
      }
      if (++tries < 12) requestAnimationFrame(function () { requestAnimationFrame(check); });
      else if (done) done();
    }
    el.scrollIntoView({ block: 'start' });
    requestAnimationFrame(function () { requestAnimationFrame(check); });
  }
  function target(hash) {
    if (!hash || hash.length < 2) return null;
    try { return document.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) { return null; }
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest ? ev.target.closest('a[href*="#"]') : null;
    if (!a || a.target === '_blank' || ev.defaultPrevented) return;
    var url;
    try { url = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname) return;
    var el = target(url.hash);
    if (!el) return;
    ev.preventDefault();
    settle(el, function () { if (history.pushState) history.pushState(null, '', url.hash); });
  });
  window.addEventListener('load', function () {
    var el = target(location.hash);
    if (el) settle(el);
  });
  /* Concept's page-transition code navigates in-page links itself (the click above never sees them,
     and a same-document hash change fires no load), so the hash change is the one event every path
     shares — a click the theme handled, a pasted URL, back/forward. pushState above fires none. */
  window.addEventListener('hashchange', function () {
    var el = target(location.hash);
    if (el) settle(el);
  });
})();

/* 2026-09-11 (session 6, Karol) — the system builder in a modal. <builder-modal> (snippets/builder-modal.liquid, in the layout) is
   Concept's QuickView with another content selector: it fetches /pages/build-your-system as it is (a ?view= would fall back to the plain page
   template, not page.builder) and injects the page's .builder-modal__content — the builder with its stylesheet and script (Concept's
   setInnerHTML re-creates the script tag; system-builder.js boots the new root), the kits modal and the kit quick views (Concept hoists
   them to the body). Every link to the builder page becomes the opener (ModalElement binds [aria-controls] and prevents the link's
   default), decorated BEFORE the element is defined so the binding sees them; without this script the links still lead to the page.
   The stylesheet is attached once before the first open, so the first render is not unstyled; the hoisted inner modals are removed
   when the modal closes, so a second open never finds stale copies by id. */
(function () {
  var ID = 'BuilderModal';
  if (!document.getElementById(ID)) return;
  Array.prototype.forEach.call(document.querySelectorAll('a[href="/pages/build-your-system"]'), function (a) {
    a.setAttribute('aria-controls', ID); a.setAttribute('aria-expanded', 'false');
  });
  customElements.whenDefined('quick-view').then(function () {
    var QuickView = customElements.get('quick-view');
    class BuilderModal extends QuickView {
      get selector() { return '.builder-modal__content'; }
      /* QuickView.quickview() appends ?view=modal — for a page with a template suffix Shopify then falls back to the plain page
         template, not the assigned page.builder (measured 2026-09-11: 'Missing content in response'), so the builder page is fetched
         as it is; the rest is the QuickView's own sequence (abort, parse, #MainContent scope, setInnerHTML re-creating the scripts). */
      quickview() {
        var drawerContent = this.querySelector(this.selector);
        var url = this.getAttribute('data-product-url');
        if (this.quickviewAbortController) this.quickviewAbortController.abort();
        this.quickviewAbortController = new AbortController();
        var signal = this.quickviewAbortController.signal, self = this;
        fetch(url, { signal }).then(function (r) { return r.text(); }).then(function (text) {
          setTimeout(function () {
            if (signal.aborted) return;
            var parsed = new DOMParser().parseFromString(text, 'text/html');
            var scope = parsed.getElementById('MainContent') || parsed;
            var el = scope.querySelector(self.selector);
            if (!el) { console.error('[BuilderModal] Missing content in response:', url); self.hide(); return; }
            self.setInnerHTML(drawerContent, el.innerHTML);
            theme.a11y.trapFocus(self, self.focusElement);
            document.dispatchEvent(new CustomEvent('quickview:loaded', { detail: { productUrl: url } }));
          }, 200);
        }).catch(function (e) { if (e.name !== 'AbortError') console.error(e); });
      }
      beforeShow() {
        var href = this.dataset.stylesheet;
        if (href && !document.querySelector('link[href="' + href + '"]')) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l); }
        /* 2026-09-12 (Karol: "System Configurator" in the menu drawer, "Builder" in the dock): opened from the drawer, the drawer folds first */
        var md = document.getElementById('MenuDrawer'); if (md && md.open && typeof md.hide === 'function') md.hide();
        super.beforeShow();
      }
      afterHide() {
        super.afterHide();
        Array.prototype.forEach.call(document.querySelectorAll('x-modal[id^="KitsModal-"], quick-view[id^="Quickview-builder-"]'), function (el) { el.remove(); });
        /* 2026-09-11 (launch audit §5.6 / F30): the builder's injected <style> hides Re:amaze and the announcement bar only while
           html.co2art-builder is on — stamped by the injected content's own script, lifted here so the page gets its bubble back */
        document.documentElement.classList.remove('co2art-builder'); document.documentElement.classList.remove('co2art-ask');
      }
    }
    if (!customElements.get('builder-modal')) customElements.define('builder-modal', BuilderModal);
  });
})();

/* 2026-09-10 (session 6, Karol: "recently viewed też pod liniami koszyka") — the products the buyer has just looked at, under the
   cart drawer's lines. Concept's <recently-viewed> keeps the drawer's tab; this twin runs the same fetch (the localStorage list,
   the search section) under its own tag, so each element takes its own results from the fetched cart-drawer section. */
customElements.whenDefined('recently-viewed').then(function () {
  var RecentlyViewed = customElements.get('recently-viewed');
  class RecentlyViewedInline extends RecentlyViewed {
    init() {
      /* 2026-09-13 (performance check after the Markets switch, Karol's pick): an empty list renders an empty section — answer it
         here without a request; and one request at a time for the same list (Concept's inView and the wishlist's fallback can land
         together when the drawer opens). */
      var self = this, q = this.getQueryString();
      if (!q) { this.hidden = true; this.dispatchEvent(new CustomEvent('is-empty')); return; }
      if (this.pendingQuery === q) return;
      this.pendingQuery = q;
      fetch(this.getAttribute('data-url') + q).then(function (r) { return r.text(); }).then(function (text) {
        self.pendingQuery = null;
        var section = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        var twin = section && section.querySelector('recently-viewed-inline');
        if (twin && twin.innerHTML.trim().length) { self.innerHTML = twin.innerHTML; self.hidden = false; self.dispatchEvent(new CustomEvent('recentlyViewed:loaded')); }
        else { self.hidden = true; self.dispatchEvent(new CustomEvent('is-empty')); }
      }).catch(function (e) { self.pendingQuery = null; console.error(e); });
    }
  }
  if (!customElements.get('recently-viewed-inline')) customElements.define('recently-viewed-inline', RecentlyViewedInline);
});

/* 2026-09-12 (Karol: "zamiast recently viewed — tam może się pojawiać wishlist") — the buyer's Oxi wishlist under the cart drawer's lines.
   <wishlist-inline> (sections/cart-drawer.liquid, beside recently-viewed-inline) is Concept's RecentlyViewed with another list: the ids
   come from Oxi's localStorage (oxi_wl_list → {favorites: [{productId, variantId?}]}, the app keeps it in sync with its server for a
   signed-in customer), the fetch is the same search-section request the recently-viewed twin makes, and the cards are the twin's from
   the response (the heading swapped, the slider id renamed so the two strips never share one). Re-reads on every drawer opening and on
   Oxi's oxi-wl-updated event (add / remove in the popup). Empty → hidden, the recently-viewed strip shows as before; items → shown, the
   recently-viewed strip yields. Only Oxi's list is read; none of its code is called. */
customElements.whenDefined('recently-viewed').then(function () {
  var RecentlyViewed = customElements.get('recently-viewed');
  class WishlistInline extends RecentlyViewed {
    connectedCallback() {
      if (this.wired) return; this.wired = true;
      /* 2026-09-13 (performance check after the Markets switch, Karol's pick "Ładuj dopiero po otwarciu koszyka"): the strips wait for
         the drawer. Re-reading on Oxi's oxiwlsettings:ready (dispatched twice at load) with the drawer closed made showEmpty() force the
         recently-viewed twin's request on every page view — two cart-drawer section renders (46 KB) nobody saw; before 2026-09-12 the
         twin waited for Concept's inView. Closed drawer: forget the last list, the next drawer:afterShow reads it again. */
      var self = this, drawer = this.closest('cart-drawer') || document.getElementById('CartDrawer');
      this.drawerOpen = function () { return !drawer || drawer.hasAttribute('open'); };
      var again = function () { self.lastQuery = null; self.init(); };
      var againIfOpen = function () { if (self.drawerOpen()) again(); else self.lastQuery = null; };
      window.addEventListener('oxi-wl-updated', againIfOpen);
      document.addEventListener('oxiwlsettings:ready', function () { setTimeout(againIfOpen, 400); });
      if (drawer) drawer.addEventListener('drawer:afterShow', again);
    }
    ids() {
      try {
        var raw = localStorage.getItem('oxi_wl_list'); if (!raw) return [];
        var o = JSON.parse(raw), list = Array.isArray(o) ? o : (o && o.favorites) || [], seen = {}, out = [];
        list.forEach(function (i) { var id = i && String(i.productId || ''); if (id && !seen[id]) { seen[id] = 1; out.push(id); } });
        return out;
      } catch (e) { return []; }
    }
    getQueryString() {
      var limit = parseInt(this.getAttribute('data-limit')) || 12;
      return this.ids().slice(0, limit).map(function (id) { return 'id:' + id; }).join(' OR ');
    }
    fallback() { return this.parentElement ? this.parentElement.querySelector('recently-viewed-inline') : null; }
    showEmpty() {
      this.hidden = true; this.innerHTML = '';
      var rv = this.fallback();
      if (rv) {
        /* the recently-viewed twin initialises only when Concept's inView sees it — hidden behind a filled wishlist it never fetched, so ask it now */
        if (rv.innerHTML.trim().length) rv.hidden = false;
        else if (typeof rv.init === 'function') { rv.hidden = false; if (this.drawerOpen()) rv.init(); }
      }
      this.dispatchEvent(new CustomEvent('is-empty'));
    }
    init() {
      var self = this, q = this.getQueryString();
      if (!q) { this.lastQuery = ''; this.showEmpty(); return; }
      if (q === this.lastQuery) return;
      this.lastQuery = q;
      fetch(this.getAttribute('data-url') + q).then(function (r) { return r.text(); }).then(function (text) {
        if (self.lastQuery !== q) return;
        var section = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        var twin = section && section.querySelector('recently-viewed-inline');
        if (twin && twin.innerHTML.trim().length) {
          self.innerHTML = twin.innerHTML.replace(/RecentUnder-/g, 'WishUnder-');
          var h = self.querySelector('.recommend__title'); if (h && self.getAttribute('data-heading')) h.textContent = self.getAttribute('data-heading');
          self.hidden = false;
          var rv = self.fallback(); if (rv) rv.hidden = true;
          self.dispatchEvent(new CustomEvent('wishlist:loaded'));
        } else { self.showEmpty(); }
      }).catch(function (e) { console.error(e); });
    }
  }
  if (!customElements.get('wishlist-inline')) customElements.define('wishlist-inline', WishlistInline);
});


/* 2026-09-10 (session 7, Karol) — two doors. (1) The floating tab at the left (Concept's newsletter-popup "floating" block, the social
   icons off — "social media nie są dla nas łaskawe") spins Privy's wheel of vouchers instead of opening the newsletter modal: Privy's
   SpinToWin display 1621765 (measured on the live site: Free Drop Checker Kit / Free Flux_ Diffuser / 10-15-20 % off — an e-mail for
   the base every time). Privy.showOnlyDisplay(id) shows one display by its id; the click is caught in the capture phase, before
   Concept's ModalElement acts on the button's aria-controls. Without Privy on the page the button keeps opening the newsletter modal.
   (2) "Ask our assistant" — any [data-ask-assistant] element opens the Re:amaze shoutbox (the AI chat lives there): the widget's own launcher is
   clicked (reamaze.popup() opens nothing — measured); without the widget the page goes to /pages/contact. First door: the builder's bar. */
(function () {
  var WHEEL = 1621765;
  /* 2026-09-11 14:15 (Karol, after seeing the fold: "przyklejony cały guzik … do bocznej ściany na mobile, jak na us"): no folding — on the phone
     the whole tab is glued to the left edge instead (assets/co2art.css); the 10-s fold and the folded-tap branch of 13:2x–14:07 are gone. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('.newsletter-bar__button');
    if (!t) return;
    if (!window.Privy || typeof window.Privy.showOnlyDisplay !== 'function') return;
    e.preventDefault(); e.stopImmediatePropagation();
    try { window.Privy.showOnlyDisplay(WHEEL); } catch (err) { console.error('[co2art] the wheel did not open', err); }
  }, true);
  var panelOpen = function () { return Array.prototype.some.call(document.querySelectorAll('#reamazejs-container *'), function (e) { var r = e.getBoundingClientRect(); return r.width > 250 && r.height > 200; }); };
  /* 2026-10-03 (co2art-ai marketing R-NEW188, the contact page; Karol's form D5): a door may carry the visitor's question. Re:amaze has no
     API for it (docs + reamaze.js read 2026-10-03), so once the chat's composer exists — #action-bar textarea[name="message[body]"] in the
     shoutbox's same-origin about:blank iframe, an UNCONTROLLED field whose send handler reads the DOM — the text goes in and the
     composer's own send button is clicked (what Enter does: _submit = a click on that button). Once per door press. Missing composer or
     button = the chat stays open with the text (or empty); the page keeps the question in its own field. */
  var sendQuestion = function (question) {
    var tries = 0, t = window.setInterval(function () {
      var ta = null;
      Array.prototype.some.call(document.querySelectorAll('iframe'), function (f) {
        try {
          var d = f.contentDocument; if (!d) return false;
          ta = Array.prototype.find.call(d.querySelectorAll('#action-bar textarea[name="message[body]"]'), function (x) { return x.getBoundingClientRect().width > 50; }) || null;
          return !!ta;
        } catch (err) { return false; }
      });
      if (!ta) { if (++tries > 50) window.clearInterval(t); return; }
      window.clearInterval(t);
      ta.value = question;
      var btn = ta.form && ta.form.querySelector('button[type="submit"]');
      if (btn) window.setTimeout(function () { btn.click(); }, 150);
      else { try { ta.focus(); ta.setSelectionRange(ta.value.length, ta.value.length); } catch (err) { /* old engines */ } }
    }, 200);
  };
  var openWidget = function (w, question) {
    var html = document.documentElement; html.classList.add('co2art-ask');   /* the builder hides the widget's containers until asked (system-builder.liquid) */
    window.setTimeout(function () {
      w.click();   /* after the style recalc — on the next frame the launcher was still hidden for Re:amaze (measured) */
      /* Karol: land in the conversation at once — Re:amaze's own "Contact Us Directly" button, once the panel has rendered */
      var tries = 0, t = window.setInterval(function () {
        /* the shoutbox renders inside an about:blank iframe (same origin — measured): look through every frame's document */
        var docs = [document]; Array.prototype.forEach.call(document.querySelectorAll('#reamazejs-container iframe'), function (f) { try { if (f.contentDocument) docs.push(f.contentDocument); } catch (err) { /* cross-origin: leave it */ } });
        var btn = null;
        docs.some(function (d) { btn = Array.prototype.find.call(d.querySelectorAll('button, a, [role="button"]'), function (b) { return /contact us directly/i.test(b.textContent || ''); }); return !!btn; });
        if (btn) { window.clearInterval(t); btn.click(); if (question) sendQuestion(question); }
        else if (++tries > 40) { window.clearInterval(t); if (question) sendQuestion(question); }   /* a returning visitor lands in the conversation itself */
      }, 200);
      /* when the panel goes, the builder's rule comes back — the bubble and the cue stay out of the builder's way */
      var seen = false, c = window.setInterval(function () {
        if (panelOpen()) { seen = true; return; }
        if (seen) { window.clearInterval(c); html.classList.remove('co2art-ask'); }
      }, 600);
    }, 80);
    return true;
  };
  /* 2026-09-23 (EU audit E4-03): the contact page under the visitor's locale root — on dk.co2art.eu/en the bare /pages/contact
     was the Danish page; Shopify.routes.root is '/' or '/en/' */
  function co2artContactUrl() { var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; return r.replace(/\/?$/, '/') + 'pages/contact'; }
  /* opts (2026-10-03, R-NEW188): { question: the visitor's first message, onFail: called instead of leaving for the contact page }.
     No widget = the loader's error flag (layout/theme.liquid) or 8 s without a launcher. On the contact page itself the default fallback
     is that page's own note (contact-chat), never a reload of the same page. */
  var askFailed = function (opts) {
    if (opts && typeof opts.onFail === 'function') { opts.onFail(); return; }
    var here = document.querySelector('contact-chat');
    if (here && typeof here.chatFailed === 'function') { here.chatFailed(); return; }
    window.location.href = co2artContactUrl();
  };
  window.co2artAsk = function (opts) {
    opts = opts || {};
    var question = typeof opts.question === 'string' ? opts.question.trim() : '';
    var w = document.getElementById('reamaze-widget');
    if (w) return openWidget(w, question);
    /* 2026-09-11 (performance plan T3): the widget loads on the first interaction or after 4 s (layout/theme.liquid) — a door tapped
       before it exists asks for it now and waits for the launcher (up to 8 s); no widget at all = the fallback */
    if (typeof window.co2artLoadReamaze !== 'function' || window.co2artReamazeFailed) { askFailed(opts); return false; }
    window.co2artLoadReamaze();
    var waited = 0, wait = window.setInterval(function () {
      var el = document.getElementById('reamaze-widget');
      if (el) { window.clearInterval(wait); openWidget(el, question); }
      else if (window.co2artReamazeFailed || (waited += 200) >= 8000) { window.clearInterval(wait); askFailed(opts); }
    }, 200);
    return true;
  };
  document.addEventListener('click', function (e) {
    /* two ways to mark a door: data-ask-assistant on an element, or a link whose address ends with #ask-assistant (any theme-editor button,
       e.g. the collections' "Ask us" — Karol 2026-09-11). Not data-ask: the builder's own question blocks carry that name. */
    var t = e.target && e.target.closest && e.target.closest('[data-ask-assistant], a[href$="#ask-assistant"]');
    if (!t) return;
    e.preventDefault(); window.co2artAsk();
  });
})();

/* 2026-10-03 (co2art-ai marketing R-NEW188, plan docs/plans/2026-10-03-contact-form-to-chat.md): the contact page's question box
   (sections/contact-chat.liquid). "Start a chat" hands the typed question to co2artAsk, which opens the chat and sends it as the
   visitor's first message; an empty field opens the chat alone. When the chat cannot open, the page shows its note with the same
   question as an e-mail (mailto: subject + body) and stays where it is — never a navigation, this page is every door's fallback.
   A link ending #ask-assistant that lands here (no JavaScript on the page before) focuses the field. Concept re-runs scripts on page
   transitions: the define is guarded. */
(function () {
  if (customElements.get('contact-chat')) return;
  class ContactChat extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.field = this.querySelector('[data-contact-chat-question]');
      this.start = this.querySelector('[data-contact-chat-start]');
      this.label = this.querySelector('[data-contact-chat-label]');
      this.failed = this.querySelector('[data-contact-chat-failed]');
      this.mail = this.querySelector('[data-contact-chat-mail]');
      /* the address is read from the server-rendered mailto (inside Cloudflare's email_off), never typed into the script */
      if (this.mail) this.mail.setAttribute('data-email', (this.mail.getAttribute('href') || '').replace(/^mailto:/i, '').split('?')[0]);
      if (this.start) this.start.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
      if (this.field) this.field.addEventListener('keydown', (e) => { if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) { e.preventDefault(); this.open(); } });
      if (this.field && /#ask-assistant$/.test(window.location.hash)) this.field.focus();
    }
    open() {
      if (this._busy) return;
      this._busy = true;
      if (this.failed) this.failed.hidden = true;
      const note = this.querySelector('[data-contact-chat-busy-text]');
      if (note) { this._noteText = this._noteText || note.textContent; note.textContent = note.getAttribute('data-contact-chat-busy-text'); }
      window.setTimeout(() => { this._busy = false; if (note && this._noteText) note.textContent = this._noteText; }, 9000);
      if (typeof window.co2artAsk !== 'function') { this.chatFailed(); return; }
      window.co2artAsk({ question: this.field ? this.field.value : '', onFail: () => this.chatFailed() });
    }
    chatFailed() {
      this._busy = false;
      const note = this.querySelector('[data-contact-chat-busy-text]');
      if (note && this._noteText) note.textContent = this._noteText;
      if (this.mail) {
        const q = this.field ? this.field.value.trim() : '';
        const email = (this.mail.getAttribute('data-email') || '').trim();
        const parts = ['subject=' + encodeURIComponent(this.getAttribute('data-subject') || '')];
        if (q) parts.push('body=' + encodeURIComponent(q));
        this.mail.setAttribute('href', 'mailto:' + email + '?' + parts.join('&'));
      }
      if (this.failed) {
        this.failed.hidden = false;
        this.failed.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.failed.focus({ preventScroll: true });
      }
    }
  }
  customElements.define('contact-chat', ContactChat);
})();

/* 2026-09-11 (Karol, after the publish): the "New here? Sign up and get 10% off" newsletter popup no longer opens by itself. Concept's
   <newsletter-modal> skips its timed open when its own "seen" cookie (concept:newsletter-popup, set by the modal on close) is present,
   so that cookie is set here, before the element upgrades — this script is deferred from the head, the section's newsletter-popup.js
   is deferred from the body, so it runs first. The modal itself stays in the page: the wheel tab's fallback and any [aria-controls]
   door still open it, and a submitted form still shows its message (that path ignores the cookie). Disabling the section would have
   taken the wheel tab with it (the "floating" block lives in the same section). */
(function () {
  try {
    if (!/(^|;)\s*concept:newsletter-popup\s*=/.test(document.cookie)) document.cookie = 'concept:newsletter-popup=true; max-age=' + (365 * 24 * 60 * 60) + '; path=/';
  } catch (e) { /* cookies blocked: the vendor's own cookiesEnabled() check then skips the popup as well */ }
})();

/* 2026-09-11 (Karol: the returns page's tabs) — the outgoing theme's tab pattern inside page bodies (ul.tabs a[href="#id"] +
   ul.tabs-content li#id): one pane at a time, no jump under the sticky header, a deep link (#step2) opens its tab on load. */
(function () {
  function select(wrap, id) {
    var pane = wrap.querySelector('.tabs-content > li[id="' + id + '"]'); if (!pane) return false;
    wrap.querySelectorAll('ul.tabs a').forEach(function (x) { x.classList.toggle('active', x.getAttribute('href') === '#' + id); });
    wrap.querySelectorAll('.tabs-content > li').forEach(function (li) { li.classList.toggle('active', li === pane); });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.rte ul.tabs a[href^="#"]'); if (!a) return;
    var wrap = a.closest('.rte'); if (!wrap) return;
    var id = a.getAttribute('href').slice(1);
    if (select(wrap, id)) { e.preventDefault(); try { history.replaceState(null, '', '#' + id); } catch (err) {} }
  });
  var h = location.hash.slice(1), pane = h && document.querySelector('.rte .tabs-content > li[id="' + h + '"]');
  if (pane) select(pane.closest('.rte'), h);
})();


/* 2026-09-11 (the CO2Artists wall from the CRM — co2art-ai docs/plans/2026-09-13-co2artists-wall-theme-KICKOFF.md S3, R-NEW116): the artist
   post's modal. A wall tile whose post carries products (data-wall-post, aria-controls="ArtistPostModal" — the home row, the CO2Artists page,
   the Inspiration page, the product page's row) is an opener bound by Concept's ModalElement, which also prevents the link's default. In the
   capture phase, before the modal opens, the tile's own <template> (snippets/artist-post-card.liquid — the photo or the player, the credit,
   the caption, the products) is cloned into the shell (snippets/artist-post-modal.liquid); after the modal closes (Concept's modal:afterHide)
   the content is emptied, so a playing video stops and the next open starts clean. Add to cart = the kit composer's sequence (/cart/add.js
   with the bundled sections → cartUpdate → the cart drawer opens over the modal); the variant <select> drives the price; "more" unfolds the caption. */
(function () {
  var ID = 'ArtistPostModal';
  function modal() { return document.getElementById(ID); }
  function content() { var m = modal(); return m && m.querySelector('.artist-post-modal__content'); }
  /* 2026-09-11 (Karol: "strzałki w prawo i lewo … by user mógł szybko przechodzić pomiędzy postami"): the wall's tiles are remembered at
     open (the row or the mosaic the tile sits in), a neighbour fills the same shell — no close, no fetch — and an arrow hides at the row's end. */
  var wall = { tiles: [], index: -1 };
  function fill(tile) {
    var tpl = tile.querySelector('template[data-wall-post-tpl]'), box = content();
    if (!tpl || !box) return false;
    box.innerHTML = '';
    box.appendChild(tpl.content.cloneNode(true));
    box.scrollTop = 0;
    var prev = box.querySelector('[data-apm-nav="-1"]'), next = box.querySelector('[data-apm-nav="1"]');
    if (prev) prev.hidden = !(wall.index > 0);
    if (next) next.hidden = !(wall.index >= 0 && wall.index < wall.tiles.length - 1);
    return true;
  }
  function step(d) {
    var i = wall.index + d;
    if (i < 0 || i >= wall.tiles.length) return;
    wall.index = i; fill(wall.tiles[i]);
  }
  document.addEventListener('click', function (e) {
    var tile = e.target && e.target.closest && e.target.closest('[data-wall-post]');
    if (!tile) return;
    var scope = tile.closest('.section-instagram-wall, .section-artist-posts') || document;
    wall.tiles = Array.prototype.filter.call(scope.querySelectorAll('[data-wall-post]'), function (t) { return t.querySelector('template[data-wall-post-tpl]'); });
    wall.index = wall.tiles.indexOf(tile);
    if (!fill(tile)) { e.stopPropagation(); return; }   /* no template (a proxy that dropped it) or no shell: the modal must not open empty — stopping the capture-phase event keeps ModalElement's own click handler from running, and the link's default takes the reader to the post */
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-apm-nav]');
    if (!b) return;
    e.preventDefault(); step(parseInt(b.getAttribute('data-apm-nav'), 10) || 0);
  });
  document.addEventListener('keydown', function (e) {
    var m = modal(); if (!m || !m.hasAttribute('open')) return;
    if (e.target && /^(INPUT|SELECT|TEXTAREA)$/.test(e.target.tagName)) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); } else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
  });
  document.addEventListener('DOMContentLoaded', function () {
    var m = modal(); if (!m) return;
    m.addEventListener('modal:afterHide', function () { var box = content(); if (box) box.innerHTML = ''; wall.tiles = []; wall.index = -1; });
  });
  /* inside the modal: "more", the variant's price, Add to cart */
  document.addEventListener('click', function (e) {
    var more = e.target && e.target.closest && e.target.closest('[data-apm-more]');
    if (more) {
      var p = more.closest('.apm__caption'); if (!p) return;
      p.querySelector('.apm__short').hidden = true; p.querySelector('.apm__full').hidden = false; more.remove();
      return;
    }
    var add = e.target && e.target.closest && e.target.closest('[data-apm-add]');
    if (!add || add.disabled) return;
    e.preventDefault();
    var row = add.closest('[data-apm-product]'), pick = row && row.querySelector('[data-apm-variant]'), err = row && row.querySelector('[data-apm-err]');
    var id = pick && pick.value; if (!id) return;
    var T = window.theme || {};
    if (!T.routes || !T.utils || !T.utils.fetchConfig) { window.location.href = T.routes && T.routes.cart_add_url ? T.routes.cart_add_url.replace('/add', '/' + id + ':1') : '/cart/' + id + ':1'; return; }
    var label = add.querySelector('.btn-text'), was = label ? label.textContent : '';
    add.disabled = true; if (label) label.textContent = add.dataset.msgAdding || 'Adding…'; if (err) { err.hidden = true; err.textContent = ''; }
    var sections = []; document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var config = T.utils.fetchConfig('javascript'); config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }], sections: sections, sections_url: window.location.pathname });
    fetch(T.routes.cart_add_url, config).then(function (r) { return r.json(); }).then(function (parsed) {
      if (parsed.status) throw new Error(parsed.description || parsed.message || add.dataset.msgFailed || 'Could not add it to the cart.');
      return fetch(T.routes.cart_url, T.utils.fetchConfig('json', 'GET')).then(function (r) { return r.json(); }).then(function (cartJson) {
        cartJson.sections = parsed.sections;
        T.pubsub.publish(T.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'artist-post-modal', productVariantId: id, cart: cartJson });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsed } }));
        var drawer = document.querySelector('cart-drawer'); if (drawer && typeof drawer.show === 'function') drawer.show(add);
        if (label) label.textContent = add.dataset.msgAdded || 'Added ✓';
        window.setTimeout(function () { add.disabled = false; if (label) label.textContent = was; }, 1800);
      });
    }).catch(function (ex) {
      add.disabled = false; if (label) label.textContent = was;
      if (err) { err.textContent = (ex && ex.message) || add.dataset.msgFailed || 'Could not add it to the cart.'; err.hidden = false; }
    });
  });
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.matches && e.target.matches('select[data-apm-variant]');
    if (!sel) return;
    var row = e.target.closest('[data-apm-product]'), opt = e.target.options[e.target.selectedIndex], price = row && row.querySelector('[data-apm-price]');
    if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
  });
})();

/* CO2Art 2026-09-19 — co2art.eu conversion changes C1 (co2art-ai docs/plans/2026-09-19-eu-conversion-changes-PLAN.md; Karol's form D1 = C):
   the phone's buy bar from the first paint. Concept's product-sticky-form shows only after the product form has scrolled away; here it is
   on whenever the real Add to cart is not fully visible — below the fold behind a long title, a sliver at the bottom edge (threshold 1),
   covered by the open cookie banner, scrolled past — and the footer is not reached. While the cookie banner is open the bar rides above
   it (--co2-banner-h), so the banner's own buttons stay free. The Re:amaze bubble follows (html.co2-buybar-on, assets/co2art.css).
   Phones only; the kits (kit-sticky-form) are untouched. */
(function () {
  function init() {
    var wrap = document.querySelector('.co2-pdp'); if (!wrap || !window.IntersectionObserver) return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return;
    var bar = wrap.querySelector('product-sticky-form'); var btn = wrap.querySelector('.product-form__submit'); var foot = document.querySelector('.footer-group');
    if (!bar || !btn || bar.dataset.co2Bar) return;
    bar.dataset.co2Bar = '1'; bar.classList.add('co2-bar');
    var banner = document.getElementById('CookieBanner');
    var full = true, atFoot = false;
    function bannerTop() {
      if (!banner || !banner.hasAttribute('open')) return null;
      var inner = banner.querySelector('.drawer__inner'); return inner ? inner.getBoundingClientRect().top : null;
    }
    function paint() {
      var bt = bannerTop(), covered = bt !== null && btn.getBoundingClientRect().bottom > bt;
      var on = (!full || covered) && !atFoot;
      bar.classList.toggle('co2-show', on); bar.classList.toggle('co2-hide', !on);
      document.documentElement.classList.toggle('co2-buybar-on', on);
      document.documentElement.style.setProperty('--co2-banner-h', (bt !== null ? Math.max(0, Math.ceil(window.innerHeight - bt) + 1) : 0) + 'px');
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.target === btn) full = e.intersectionRatio >= 0.98; else atFoot = e.isIntersecting; });
      paint();
    }, { threshold: [0, 0.98, 1] });
    io.observe(btn); if (foot) io.observe(foot);
    if (banner) {
      /* the banner slides in and out (Concept's drawer): read it again after its transition; while it is open, scrolling decides
         whether it covers the button, so paint on scroll too (one frame at most) */
      new MutationObserver(function () { paint(); setTimeout(paint, 80); setTimeout(paint, 650); }).observe(banner, { attributes: true, attributeFilter: ['open', 'hidden', 'class'] });
      var queued = false;
      window.addEventListener('scroll', function () { if (queued || !banner.hasAttribute('open')) return; queued = true; requestAnimationFrame(function () { queued = false; paint(); }); }, { passive: true });
    }
    paint();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('page:loaded', init);
})();

/* 2026-09-19 (push A2, snippets/kit-rating.liquid) — the kit rating popover. A kit's stars are the combined reviews of its parts; the
   line is a disclosure button (aria-expanded) that opens a small panel listing each part, its stars and its review count. A tap or a
   click toggles it and moves focus into the panel; with a fine pointer it also opens on hover (no focus move) and closes when the pointer
   leaves, unless a click pinned it. Escape, the close button, a click outside or focus leaving it closes it; focus goes back to the button
   whenever it was inside. Delegated on the document, so the quick view and Concept's page:loaded swaps need no init. */
(function () {
  var HOVER = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  var timer = null;
  function parts(w) { return { btn: w.querySelector('.kitrate__btn'), panel: w.querySelector('.kitrate__panel') }; }
  function openAll() { return document.querySelectorAll('.kitrate[data-open]'); }
  function open(w, how) {
    var x = parts(w); if (!x.btn || !x.panel) return;
    openAll().forEach(function (o) { if (o !== w) close(o, false); });
    x.panel.hidden = false; x.btn.setAttribute('aria-expanded', 'true'); w.setAttribute('data-open', how);
    if (how === 'pin') { try { x.panel.focus({ preventScroll: true }); } catch (e) { x.panel.focus(); } }
  }
  function close(w, refocus) {
    var x = parts(w); if (!x.btn || !x.panel) return;
    var inside = w.contains(document.activeElement) && document.activeElement !== x.btn;
    x.panel.hidden = true; x.btn.setAttribute('aria-expanded', 'false'); w.removeAttribute('data-open');
    if (refocus && inside) { try { x.btn.focus({ preventScroll: true }); } catch (e) { x.btn.focus(); } }
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var btn = t.closest('.kitrate__btn');
    if (btn) { var w = btn.closest('.kitrate'); if (w.getAttribute('data-open') === 'pin') close(w, true); else open(w, 'pin'); return; }
    var cl = t.closest('.kitrate__close');
    if (cl) { close(cl.closest('.kitrate'), true); return; }
    openAll().forEach(function (o) { if (!o.contains(t)) close(o, false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') openAll().forEach(function (o) { close(o, true); });
  });
  document.addEventListener('focusin', function (e) {
    openAll().forEach(function (o) { if (!o.contains(e.target)) close(o, false); });
  });
  document.addEventListener('mouseover', function (e) {
    if (!HOVER || !HOVER.matches || !e.target || !e.target.closest) return;
    var w = e.target.closest('.kitrate'); if (!w) return;
    clearTimeout(timer);
    if (!w.hasAttribute('data-open')) open(w, 'hover');
  });
  document.addEventListener('mouseout', function (e) {
    if (!HOVER || !HOVER.matches || !e.target || !e.target.closest) return;
    var w = e.target.closest('.kitrate');
    if (!w || (e.relatedTarget && w.contains(e.relatedTarget)) || w.getAttribute('data-open') !== 'hover') return;
    clearTimeout(timer);
    timer = setTimeout(function () { if (w.getAttribute('data-open') === 'hover') close(w, false); }, 250);
  });
})();

/* 2026-09-19 (conversion changes push B, C6 — co2art-ai docs/plans/2026-09-19-eu-conversion-changes-PLAN.md "Push B"; Karol's D4 = carry
   the cart) — the cart travels with the visitor to another of our Markets domains. Shopify's carts and the discount_code cookie belong to the
   host: every door (the geo bar's "Yes", the language picker's links, the drawer's country list, the head redirect of a returning visitor)
   emptied the cart and dropped the code (measured 2026-09-19: 3 → 0 items, AC20E → none). Variant ids are the same on every domain (one shop).
   LEAVING — window.co2artCarry.url(target) reads /cart.js (at most 1.5 s) and returns the target with ?co2cart=<base64url JSON
   [[variant, qty, {properties}], …]> (`_kit` / `_builder` ride in the properties) and &co2code=<the applied code>; the head redirect
   (layout/theme.liquid) prints the same lines from Liquid. Never to co2art.us (another shop, other variant ids).
   ARRIVING (any page): the parameters leave the address at once (history.replaceState); each line is added only up to the SOURCE quantity
   (a line already in this cart counts — a bounce back never doubles it: MERGE, never replace), in ONE POST /cart/add.js; the code through
   /discount/<code>; a sessionStorage mark makes one attempt per payload (never a loop); crawlers and webdriver only lose the parameters.
   On the cart page the page reloads once, so the server-rendered lines show. */
(function () {
  var BOT = /bot|crawler|spider|crawling|slurp|bingpreview|facebookexternalhit|embedly|quora|pinterest|whatsapp|telegram|lighthouse|pagespeed|gtmetrix|ahrefs|semrush|screaming frog|headlesschrome|chrome-lighthouse|google-inspectiontool|duckduck|yandex|baidu|applebot|petalbot|linkedinbot|twitterbot|discordbot|slackbot/i;
  var MAX_LINES = 50, CODE = /^[A-Za-z0-9_-]{1,64}$/;
  /* our own Markets domains: the GENERATED map (snippets/market-map.liquid via snippets/market-menu.liquid, R-NEW126), never a typed list;
     the pattern below is the fallback for a page without the picker. co2art.us is another shop and is never one of them. */
  function ours(host) {
    host = String(host || '').toLowerCase();
    if (/(?:^|\.)co2art\.us$/.test(host)) return false;
    var list = window.co2artMarketHosts;
    if (list && list.length) return list.indexOf(host) > -1;
    return /(?:^|\.)co2art\.(?:[a-z]{2,3}|co\.uk)$/.test(host);
  }
  /* push C (2026-09-20, Karol's D4b): the visitor's ANSWER travels with them — 'y' / 'n' only once they answered on this host
     (never `no_interaction`), read from Shopify's consent API (the same one the banner writes, assets/cookie-banner.js) */
  function consentValue() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.getTrackingConsent !== 'function') return '';
      var v = cp.getTrackingConsent();
      return v === 'yes' ? 'y' : v === 'no' ? 'n' : '';
    } catch (e) { return ''; }
  }
  function enc(s) { return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function dec(s) { s = String(s).replace(/-/g, '+').replace(/_/g, '/').replace(/=+$/, ''); while (s.length % 4) s += '='; return decodeURIComponent(escape(atob(s))); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function props(p) {
    /* an array of [key, value] pairs (what Liquid's `properties | json` prints) is read as the object it stands for */
    if (Array.isArray(p)) { var pairs = {}; p.forEach(function (kv) { if (Array.isArray(kv) && kv.length === 2 && typeof kv[0] === 'string') pairs[kv[0]] = kv[1]; }); p = pairs; }
    var o = {}, n = 0; if (p && typeof p === 'object') Object.keys(p).sort().forEach(function (k) { if (p[k] !== null && p[k] !== '') { o[k] = p[k]; n++; } }); return n ? o : null;
  }
  function same(a, b) { return JSON.stringify(props(a) || {}) === JSON.stringify(props(b) || {}); }
  function cookieCode() { var m = document.cookie.match(/(?:^|; )discount_code=([^;]*)/); var c = m ? decodeURIComponent(m[1]) : ''; return CODE.test(c) ? c : ''; }
  /* one short-lived cache: the drawer's country list warms it when the visitor opens the list, so the hop does not wait for /cart.js
     (measured on the copy 2026-09-20: that read ran past the 1.5-s budget on a phone and the form left with the answer alone) */
  var cartCache = { at: 0, cart: null };
  function getCart(fresh) {
    if (!fresh && cartCache.cart && Date.now() - cartCache.at < 8000) return Promise.resolve(cartCache.cart);
    return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) { cartCache = { at: Date.now(), cart: c }; } return c; });
  }
  /* the country / language list is lazy (Concept's api-button): its button click is the moment to warm the cart */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[aria-controls^="LocalizationCountry"], [aria-controls^="LocalizationLanguage"]') : null;
    if (b) getCart(true).catch(function () { /* the hop falls back to its own read */ });
  }, true);

  function query(cart) {
    var lines = (cart && cart.items || []).slice(0, MAX_LINES).map(function (i) { var l = [i.variant_id, i.quantity], p = props(i.properties); if (p) l.push(p); return l; });
    var code = '';
    (cart && cart.discount_codes || []).forEach(function (d) { if (!code && d && CODE.test(d.code || '') && d.applicable !== false) code = d.code; });
    code = code || cookieCode();
    var q = [];
    if (lines.length) q.push('co2cart=' + enc(JSON.stringify(lines)));
    if (code) q.push('co2code=' + encodeURIComponent(code));
    var c = consentValue();
    if (c) q.push('co2consent=' + c);
    return q.join('&');
  }
  /* the carried target, or the target unchanged when nothing rides, the host is not ours, or /cart.js does not answer in 1.5 s */
  function url(target) {
    var u; try { u = new URL(target, location.href); } catch (e) { return Promise.resolve(target); }
    if (!ours(u.hostname) || u.hostname === location.hostname || /[?&]co2cart=/.test(u.search)) return Promise.resolve(target);
    var bare = consentValue() ? 'co2consent=' + consentValue() : '';
    var join = function (q) { return q ? u.origin + u.pathname + (u.search ? u.search + '&' : '?') + q + u.hash : target; };
    return new Promise(function (resolve) {
      var done = false, finish = function (v) { if (!done) { done = true; resolve(v); } };
      /* the consent answer never waits for the cart: a slow /cart.js still leaves with it */
      setTimeout(function () { finish(join(bare)); }, 1500);
      getCart().then(function (cart) {
        finish(join(cart ? query(cart) : bare));
      }).catch(function () { finish(join(bare)); });
    });
  }
  window.co2artCarry = { url: url, ours: ours };

  /* DOOR — the language picker (snippets/market-menu.liquid: header dropdown + drawer modal), a plain link to another domain */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[data-market-lang]') : null;
    if (!a || a.target === '_blank') return;
    var u; try { u = new URL(a.href); } catch (x) { return; }
    if (!ours(u.hostname) || u.hostname === location.hostname) return;
    e.preventDefault();
    url(a.href).then(function (h) { location.href = h; });
  }, true);

  /* DOOR — the drawer's country list (Concept's localization-listbox: its item click sets the value, return_to = the path, then
     form.submit() — no submit event to hook). Taken over in the capture phase: the same three steps, return_to carrying the cart; Shopify
     keeps return_to's query string across its /localization hop to the market's domain (measured 2026-09-19). */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('form[is="localization-listbox"] a[data-value]') : null;
    if (!a) return;
    var form = a.closest('form'), input = form.querySelector('input[name="locale_code"], input[name="country_code"]'), back = form.querySelector('input[name="return_to"]');
    if (!input || !back || form.dataset.co2Carrying) return;
    e.preventDefault(); e.stopImmediatePropagation();
    form.dataset.co2Carrying = '1';
    input.value = a.getAttribute('data-value');
    /* exactly one submit: the 1.5-s fallback and a late /cart.js must not both send the form (measured on the copy 2026-09-20) */
    var sent = false;
    var go = function (q) { if (sent) return; sent = true; back.value = location.pathname + (q ? '?' + q : ''); form.submit(); };
    var bare = function () { return consentValue() ? 'co2consent=' + consentValue() : ''; };
    /* this door submits a form (a round trip anyway), so the cart read gets 3 s here; Shopify's own /localization transfer carries the
       cart and the code across the hop as well (measured 2026-09-20), so a slow read costs nothing but our own parameters */
    var t = setTimeout(function () { go(bare()); }, 3000);
    getCart().then(function (cart) { clearTimeout(t); go(cart ? query(cart) : bare()); }).catch(function () { clearTimeout(t); go(bare()); });
  }, true);

  /* ARRIVING */
  var q; try { q = new URLSearchParams(location.search); } catch (e) { return; }
  var raw = q.get('co2cart'), code = q.get('co2code'), consent = q.get('co2consent');
  /* Shopify's own cross-domain hop (the drawer's country form) lands with shpxid and without a referrer — read both before they are stripped */
  var fromUs = (function () { try { var r = document.referrer ? new URL(document.referrer).hostname : ''; return !!(r && ours(r) && r !== location.hostname); } catch (e) { return false; } })() || /[?&]shpxid=/.test(location.search);
  if (raw === null && code === null && consent === null) return;
  q.delete('co2cart'); q.delete('co2code'); q.delete('co2consent');
  var rest = q.toString();
  try { history.replaceState(history.state, '', location.pathname + (rest ? '?' + rest : '') + location.hash); } catch (e) { /* the parameters stay; harmless */ }
  if (navigator.webdriver || BOT.test(navigator.userAgent || '') || !window.fetch) return;
  var lines = [];
  try {
    var parsed = raw ? JSON.parse(dec(raw)) : [];
    if (Array.isArray(parsed)) parsed.slice(0, MAX_LINES).forEach(function (l) {
      var id = parseInt(l && l[0], 10), n = parseInt(l && l[1], 10);
      if (id > 0 && n > 0 && n < 1000) lines.push({ id: id, quantity: n, properties: props(l[2]) });
    });
  } catch (e) { lines = []; }
  code = code && CODE.test(code) ? code : '';
  /* push C (D4b): the visitor answered the banner on one of our hosts — the same answer applies here, so they are asked once.
     Guards: only a hop FROM one of our own hosts (referrer, or Shopify's shpxid on the /localization hop) — a link a stranger built
     can never set a consent; never for a crawler; and THIS host's own answer always wins (only `no_interaction` is filled in). */
  if ((consent === 'y' || consent === 'n') && fromUs) {
    (function (yes) {
      var apply = function () {
        try {
          var cp = window.Shopify && window.Shopify.customerPrivacy;
          if (!cp || typeof cp.getTrackingConsent !== 'function' || cp.getTrackingConsent() !== 'no_interaction') return;
          cp.setTrackingConsent(yes, function () {
            try { var b = document.querySelector('cookie-banner'); if (b && typeof b.hide === 'function') b.hide(); } catch (e) { /* the banner closes on its own rules */ }
          });
        } catch (e) { /* nothing */ }
      };
      try {
        if (window.Shopify && window.Shopify.customerPrivacy) apply();
        else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1', onLoad: apply }]);
      } catch (e) { /* nothing */ }
    })(consent === 'y');
  }
  if (!lines.length && !code) return;
  var mark = 'co2art_carry:' + String(raw || '').slice(0, 300) + '|' + code;
  try { if (sessionStorage.getItem(mark)) return; sessionStorage.setItem(mark, '1'); } catch (e) { /* private mode: the quantity rule still prevents doubling */ }
  var T = window.theme || {};
  function sections() { var arr = []; try { document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: arr } })); } catch (e) { /* none */ } return arr; }
  getCart().then(function (cart) {
    var adds = [];
    lines.forEach(function (l) {
      var have = 0;
      ((cart && cart.items) || []).forEach(function (i) { if (i.variant_id === l.id && same(i.properties, l.properties)) have += i.quantity; });
      if (l.quantity > have) { var it = { id: l.id, quantity: l.quantity - have }; if (l.properties) it.properties = l.properties; adds.push(it); }
    });
    var added = adds.length ? fetch(root() + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: adds, sections: sections(), sections_url: location.pathname }) }).then(function (r) { return r.json(); }).catch(function () { return null; }) : Promise.resolve(null);
    return added.then(function (res) {
      var applied = code ? fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root() + 'cart.js'), { credentials: 'same-origin' }).catch(function () { return null; }) : Promise.resolve(null);
      return applied.then(function () {
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        return getCart().then(function (c2) {
          if (!c2) return;
          if (res && res.sections) c2.sections = res.sections;
          if (T.pubsub && T.pubsub.PUB_SUB_EVENTS) T.pubsub.publish(T.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'co2art-carry', cart: c2 });
        });
      });
    });
  }).catch(function () { /* a courtesy: a failure leaves this cart as it was */ });
})();

/* CO2Art 2026-09-28 — findings-repair F66: on phones the Re:amaze bubble (a fixed div, inline bottom 55px / left 22px, the top z-index)
   sat on the left end of the cookie banner's Accept button on EVERY page — a tap on that corner opened the chat instead of answering the
   banner; R-NEW150 (2026-09-19) lifted it only over the product page's buy bar. While #CookieBanner is open the bubble now rides above
   the banner card everywhere (html.co2-banner-open + --co2-banner-h, assets/co2art.css); on a product page the buy-bar rule
   (html.co2-buybar-on) keeps precedence and its own measurement. Nothing else moves; the banner and its consent call are untouched. */
(function () {
  function init() {
    var banner = document.getElementById('CookieBanner'); if (!banner || banner.dataset.co2Lift) return;
    banner.dataset.co2Lift = '1';
    var root = document.documentElement;
    function paint() {
      var open = banner.hasAttribute('open');
      var inner = open ? banner.querySelector('.drawer__inner') : null;
      var bt = inner ? inner.getBoundingClientRect().top : null;
      var h = bt !== null ? Math.max(0, Math.ceil(window.innerHeight - bt) + 1) : 0;
      root.classList.toggle('co2-banner-open', open && h > 0);
      if (!root.classList.contains('co2-buybar-on')) root.style.setProperty('--co2-banner-h', h + 'px');
    }
    new MutationObserver(function () { paint(); setTimeout(paint, 80); setTimeout(paint, 650); })
      .observe(banner, { attributes: true, attributeFilter: ['open', 'hidden', 'class'] });
    window.addEventListener('resize', paint);
    paint(); setTimeout(paint, 650);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

